import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Grid, IconButton, List, ListItem, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef, useState } from "react";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";


interface IAddProps {
  photosBanniere: any;
  setPhotosBanniere: (x: any) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    photosBanniere,
    setPhotosBanniere
  } = props


  //hooks
  const selectBannierePhoto: any = useRef(null);
  const [loadingChargehoto, setLoadingChargePhoto] = React.useState<boolean>(false);


  //Charger les images puis les transformer en base 64
  const handleAddBannierePhotos = (event: any) => {
    setLoadingChargePhoto(true)
    const fileList = event.target.files;
    const fileObjects: any = Array.from(fileList).map((file: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lit le fichier en tant que DataURL
      // Crée une promesse pour attendre la fin de la lecture du fichier
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            url: reader.result // Récupère le résultat en tant que DataURL
          });
        };
      });
    });
    // Attend que toutes les promesses soient résolues
    Promise.all(fileObjects).then((results) => {
      setPhotosBanniere([...photosBanniere, ...results]);
      setLoadingChargePhoto(false)
    });
  };


  const handleDelete = (currentIndex: number) => {
    let newData = [...photosBanniere]
    const res = newData.filter((item, index) => index !== currentIndex)
    setPhotosBanniere(res)
  };


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger les images de la galérie">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ArtTrackIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectBannierePhoto?.current?.click();
                  }}
                >
                  Charger les images de la Bannière
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="BannierePhoto"
                ref={selectBannierePhoto}
                onChange={handleAddBannierePhotos}
              />
            </Grid>

            {photosBanniere && photosBanniere.length > 0 && (
              <div style={{ width: "100%", height: "55vh", overflow: "auto", }}>
                <Box sx={{ flexGrow: 1, width: "100%" }}>
                  <List dense={true}>
                    {photosBanniere.map((photo: any, index: number) => (
                      <div key={index}>
                        <ListItem
                          secondaryAction={
                            <IconButton
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          }
                        >
                          <ListItem>
                            <img src={photo.url} alt={photo.name} style={{ width: "30%", height: "30%" }} />
                          </ListItem>
                        </ListItem>
                        <Divider />
                      </div>
                    ))}
                  </List>
                </Box>
              </div>
            )}
            {loadingChargehoto && "Patientez svp..."}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};



const DialogAdd = () => {

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [photosBanniere, setPhotosBanniere] = useState<any>([]);

  //Fermer le menu
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir le menu
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer une bannière
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      //Obtenir les images de la galérie en base 64
      let imagesDuDossierEnBase64: string[] = []
      photosBanniere.map(async (item: any) => {
        imagesDuDossierEnBase64.push(item.url)
      })
      // Envoi de la requête 
      const res = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajouterbanniere", { banniereImageEnBase64: imagesDuDossierEnBase64 });
      if (res.status === 1) {
        setAddLoading(false)
        successNotify("Action effectuée avec succès");
        setPhotosBanniere([])
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handleActualiteSave ~ error:", error)
    }
  }

  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          photosBanniere={photosBanniere}
          setPhotosBanniere={setPhotosBanniere}
        />}
      actionFunc={handleSave}
      title="Bannière"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



